export default "__VITE_ASSET__948d1b6f__"